import { render, staticRenderFns } from "./dataProtection.vue?vue&type=template&id=48ae7599&scoped=true&"
import script from "./dataProtection.vue?vue&type=script&lang=js&"
export * from "./dataProtection.vue?vue&type=script&lang=js&"
import style0 from "./dataProtection.vue?vue&type=style&index=0&id=48ae7599&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ae7599",
  null
  
)

export default component.exports